<template lang="pug">
main.modal-wrapper.l-flex-column
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal()")

    main.modal-main(v-if="formAction === 'create'")
        header.modal-header
            el-steps(:active="activeStep", :align-center="true", slot="title")
                el-step(title="Connection")
                el-step(title="Configuration")

        FormConnection(
            v-if="activeStep === 0",
            :dataForm="formConnection"
            :closeModal="closeModal"
        )
        FormConfiguration(
            v-else-if="activeStep === 1",
            :dataForm="dataForm"
            :closeModal="closeModal"
        )

    main.modal-main.edit-mode(v-else-if="formAction === 'edit'")
        header.modal-header
            sectionHeader(:title="formEditTitle")
        template(v-if="formType === 'connection'")
            FormConnection(
                :dataForm="formConnection"
                :closeModal="closeModal"
            )
        template(v-else-if="formType === 'configuration'")
            FormConfiguration(
                :dataForm="dataForm"
                :closeModal="closeModal"
            )
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations } from 'vuex'
import { cloneDeep, isEmpty } from 'lodash'

import { DEM_CONNECTION_FORM_DATA, DEM_CONFIGURATION_FORM_DATA } from '@/utils/constants'

import FormConnection from './DemFormConnection'
import FormConfiguration from './DemFormConfiguration'
import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'DataEntryForm',

    components: {
        FormConnection,
        FormConfiguration,
        SectionHeader
    },

    computed: {
        ...mapState('ui/dataEntry', {
            formAction: state => state.formAction,
            formConnection: state => state.formConnection,
            formConfiguration: state => state.formConfiguration,
            formType: state => state.formType,
            connectionId: state => state.connectionId,
            displayModal: state => state.displayModal,
            activeStep: state => state.activeStep
        }),
        formEditTitle() {
            return `Edit ${this.formType}`
        },
        clickOutClose() {
            return this.activeStep < 1
        },
        dataForm() {
            return {
                ...this.formConfiguration,
                finish_alert_emails: isEmpty(this.formConfiguration.finish_alert_emails) ? [] : this.formConfiguration.finish_alert_emails
            }
        }
    },
    methods: {
        // Call to mutations
        ...mapMutations('ui/dataEntry', ['setCloseModal', 'setFormConnection', 'setFormConfiguration']),

        closeModal() {
            this.setCloseModal()
            this.setFormConnection({ formConnection: cloneDeep(DEM_CONNECTION_FORM_DATA) })
            this.setFormConfiguration({ formConfiguration: cloneDeep(DEM_CONFIGURATION_FORM_DATA) })
        }
    }
}
</script>
